import styled from 'styled-components'

const Style = styled.div`
	grid-area: scrubber;
`

export default Style
